import { $themeConfig } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    layout: {
      isRTL: localStorage.getItem('nyssma.theme.rtl') || $themeConfig.layout.isRTL,
      skin: localStorage.getItem('nyssma.theme.skin') || $themeConfig.layout.skin,
      routerTransition: localStorage.getItem('nyssma.theme.transition') || $themeConfig.layout.routerTransition,
      type: localStorage.getItem('nyssma.theme.layout') || $themeConfig.layout.type,
      contentWidth: $themeConfig.layout.contentWidth,
      menu: {
        hidden: $themeConfig.layout.menu.hidden,
      },
      navbar: {
        type: localStorage.getItem('nyssma.theme.navbar.type') || $themeConfig.layout.navbar.type,
        backgroundColor: localStorage.getItem('nyssma.theme.navbar.bg') || $themeConfig.layout.navbar.backgroundColor,
      },
      footer: {
        type: $themeConfig.layout.footer.type,
      },
    },
  },
  getters: {},
  action: {
    update_theme({ commit }, theme) {
      commit('update_theme', theme )
    }
  },
  mutations: {
    TOGGLE_RTL(state) {
      state.layout.isRTL = !state.layout.isRTL
      localStorage.setItem('nyssma.theme.rtl', state.layout.isRTL)

      document.documentElement.setAttribute('dir', state.layout.isRTL ? 'rtl' : 'ltr')
    },
    UPDATE_SKIN(state, skin) {
      state.layout.skin = skin

      // Update value in localStorage
      localStorage.setItem('nyssma.theme.skin', skin)

      // Update DOM for dark-layout
      if (skin === 'dark') document.body.classList.add('dark-layout')
      else if (document.body.className.match('dark-layout')) document.body.classList.remove('dark-layout')
    },
    UPDATE_ROUTER_TRANSITION(state, val) {
      state.layout.routerTransition = val
      localStorage.setItem('nyssma.theme.transition', val)
    },
    UPDATE_LAYOUT_TYPE(state, val) {
      state.layout.type = val
      localStorage.setItem('nyssma.theme.layout', val)
    },
    UPDATE_CONTENT_WIDTH(state, val) {
      state.layout.contentWidth = val
    },
    UPDATE_NAV_MENU_HIDDEN(state, val) {
      state.layout.menu.hidden = val
    },
    UPDATE_NAVBAR_CONFIG(state, obj) {
      Object.assign(state.layout.navbar, obj)
      localStorage.setItem('nyssma.theme.navbar.type', state.layout.navbar.type)
      localStorage.setItem('nyssma.theme.navbar.bg', state.layout.navbar.backgroundColor)
    },
    UPDATE_FOOTER_CONFIG(state, obj) {
      Object.assign(state.layout.footer, obj)
    },
    update_theme(state, layout) {
      state.layout = layout
      localStorage.setItem('nyssma.theme.skin', layout.skin)
      localStorage.setItem('nyssma.theme.layout', layout.type)
      localStorage.setItem('nyssma.theme.navbar.type', layout.navbar.type)
      localStorage.setItem('nyssma.theme.navbar.bg', layout.navbar.backgroundColor)
    }
  },
  actions: {},
}
